import styled from "styled-components";

export type FixedTooltipPlacement = "top" | "bottom";

export interface FixedTooltipSurfaceProps {
  $arrowLeft: number;
  $placement: FixedTooltipPlacement;
}

export const FixedTooltipSurface = styled.div<FixedTooltipSurfaceProps>`
  position: fixed;
  z-index: 3000;
  box-sizing: border-box;
  width: max-content;
  max-width: calc(100vw - 32px);
  padding: 14px 10px;
  border: 1px solid #3c3e44;
  border-radius: 4px;
  background: #303134;
  box-shadow: -4px 0 6px rgba(2, 10, 14, 0.32);
  pointer-events: none;
  transform: ${({ $placement }) =>
    $placement === "top" ? "translateY(-100%)" : "none"};

  &::before,
  &::after {
    position: absolute;
    left: ${({ $arrowLeft }) => `${$arrowLeft}px`};
    width: 0;
    height: 0;
    content: "";
    transform: translateX(-50%);
  }

  &::before {
    ${({ $placement }) =>
      $placement === "top"
        ? `
          bottom: -15px;
          border-top: 15px solid #3c3e44;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
        `
        : `
          top: -15px;
          border-right: 10px solid transparent;
          border-bottom: 15px solid #3c3e44;
          border-left: 10px solid transparent;
        `}
  }

  &::after {
    ${({ $placement }) =>
      $placement === "top"
        ? `
          bottom: -13px;
          border-top: 13px solid #303134;
          border-right: 9px solid transparent;
          border-left: 9px solid transparent;
        `
        : `
          top: -13px;
          border-right: 9px solid transparent;
          border-bottom: 13px solid #303134;
          border-left: 9px solid transparent;
        `}
  }
`;
